import { useState, ChangeEvent, FocusEvent, useCallback } from 'react';

import styles from './FilterNameEditor.module.scss';

interface IFilterNameEditorProps {
  filterName: string;
  filterNameInputError: string;
  setFilterName: (value: string) => void;
  setFilterNameInputError: (value: string) => void;
}

export const FilterNameEditor = ({
  filterName,
  filterNameInputError,
  setFilterName,
  setFilterNameInputError,
}: IFilterNameEditorProps) => {
  const [isFilterNameEditing, setIsFilterNameEditing] = useState(false);
  const [filterNameInputValue, setFilterNameInputValue] = useState('Новый фильтр');

  const filterNameChecker = useCallback(
    (e: ChangeEvent<HTMLInputElement>, setState: (value: string) => void) => {
      const name = e.target.value.trim();

      if (!name) {
        setFilterNameInputError('Некорректное имя фильтра');
        setState(e.target.value);

        return;
      }
      setState(e.target.value);
      setFilterNameInputError('');
    },
    [setFilterNameInputError],
  );

  const handleFilterNameInputChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => filterNameChecker(e, setFilterNameInputValue),
    [filterNameChecker],
  );

  const handleFilterNameInputBlur = useCallback(
    (e: FocusEvent<HTMLInputElement>) => {
      filterNameChecker(e, setFilterName);
      setIsFilterNameEditing(false);
    },
    [filterNameChecker, setFilterName],
  );

  const handleFilterNameClick = useCallback(() => setIsFilterNameEditing(true), []);

  return (
    <div className={styles.FilterHeader}>
      {isFilterNameEditing ? (
        <input
          className={styles.FilterNameInput}
          value={filterNameInputValue}
          onChange={handleFilterNameInputChange}
          onBlur={handleFilterNameInputBlur}
          type="text"
          autoComplete="off"
        />
      ) : (
        <>
          <div className={styles.FilterName} onClick={handleFilterNameClick}>
            {filterName}
          </div>
          <button className={styles.FilterNameEditButton} onClick={handleFilterNameClick} type="button" />
        </>
      )}
      {filterNameInputError && <div className={styles.Error}>{filterNameInputError}</div>}
    </div>
  );
};
